<script>
import { validateDateResult, isSameOrAfterDate } from '@utils/medical-date'
import { authComputed } from '@state/helpers'
import YearPicker from '@components/year-picker.vue'
import MonthPicker from '@components/month-picker.vue'
import DayPicker from '@components/day-picker.vue'
import layout from '@src/mixins/layout.vue'
export default {
  components: {
    YearPicker,
    MonthPicker,
    DayPicker,
  },
  mixins: [layout],
  props: {
    title: {
      required: true,
      type: String,
    },
    color: {
      default: 'black',
      type: String,
    },
    medicalDate: {
      default: null,
      type: String,
    },
    part: {
      default: null,
      type: String,
    },
    selectedDateType: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      day: null,
      month: null,
      year: null,
      dateError: null,
      yearMenu: false,
      monthMenu: false,
      dayMenu: false,
      localSelectedDateType: this.selectedDateType,
    }
  },
  computed: {
    ...authComputed,
    days() {
      const result = []
      result.push('--')
      for (let i = 1; i <= 31; i++) {
        result.push(i)
      }
      return result
    },
    months() {
      const result = []
      result.push('--')
      for (let i = 1; i <= 12; i++) {
        result.push(i)
      }
      return result
    },
    years() {
      const result = []
      let startYear = 1900
      for (let i = 1; i <= 13; i++) {
        result.push({
          start: startYear,
          end: startYear + 11,
        })
        startYear = startYear + 12
      }
      return result
    },
    textClass() {
      return this.color + '--text'
    },
  },
  watch: {
    medicalDate: {
      handler(newVal) {
        if (newVal) {
          if (this.part === 'year') {
            this.day = null
            this.month = null
            this.year = this.parseDateYear(newVal)
          } else if (this.part === 'month') {
            this.day = null
            this.month = this.parseDateMonth(newVal)
            this.year = this.parseDateYear(newVal)
          } else if (this.part === 'day') {
            this.day = this.parseDateDay(newVal)
            this.month = this.parseDateMonth(newVal)
            this.year = this.parseDateYear(newVal)
          } else {
            this.resetData()
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    parseDateYear(value) {
      return parseInt(value.substring(0, 4))
    },
    parseDateMonth(value) {
      return parseInt(value.substring(5, 7))
    },
    parseDateDay(value) {
      return parseInt(value.substring(8))
    },
    setToday() {
      this.day = new Date().getDate()
      this.month = new Date().getMonth() + 1
      this.year = new Date().getFullYear()
      this.setMedicalDate(false)
    },
    setMedicalDate(past) {
      this.dateError = null
      let result = {
        day: '',
        month: '',
        year: '',
      }
      if (past) {
        result = null
      } else {
        result.day = this.day
          ? String(this.day) === '--'
            ? ''
            : String(this.day)
          : ''
        result.month = this.month
          ? String(this.month) === '--'
            ? ''
            : String(this.month)
          : ''
        result.year = this.year ? String(this.year) : ''
      }
      if (!past && (result.month !== '') & (result.day !== '')) {
        if (!validateDateResult(result)) {
          this.dateError = this.$t('invalid-date')
          return
        }
      }
      if (
        !past &&
        this.serializedUser &&
        !isSameOrAfterDate(this.serializedUser.dob, result)
      ) {
        this.dateError = this.$t('date-before-birthday')
        return
      }
      this.$emit('setMedicalDate', result, past)
    },
    closeDialog() {
      this.$emit('closeMedicalDate')
    },
    resetData() {
      this.day = null
      this.month = null
      this.year = this.getCurrentYear()
    },
    getCurrentYear() {
      return new Date().getFullYear()
    },
    setYear(value) {
      this.year = value
      this.yearMenu = false
      this.dateError = null
    },
    setMonth(value) {
      this.month = value
      this.monthMenu = false
      this.dateError = null
    },
    setDay(value) {
      this.day = value
      this.dayMenu = false
      this.dateError = null
    },
    resetMonth() {
      this.day = null
      this.month = null
    },
    resetYear() {
      this.resetMonth()
      this.year = null
    },
    getSelectedDate(values) {
      this.dateError = null
      this.localSelectedDateType = values
      if (this.localSelectedDateType === 'Today') {
        this.day = new Date().getDate()
        this.month = new Date().getMonth() + 1
        this.year = new Date().getFullYear()
      } else if (this.localSelectedDateType === 'Exact_date') {
        this.day = null
        this.month = null
        this.year = null
      } else if (this.localSelectedDateType === 'Month_year') {
        this.day = null
        this.month = new Date().getMonth() + 1
        this.year = new Date().getFullYear()
      } else if (this.localSelectedDateType === 'Year_only') {
        this.day = null
        this.month = null
        this.year = new Date().getFullYear()
      } else {
        this.day = null
        this.month = null
        this.year = null
      }
    },
    getMonthInString(monthInNumber) {
      switch (monthInNumber) {
        case 1:
          return 'January'
        case 2:
          return 'February'
        case 3:
          return 'March'
        case 4:
          return 'April'
        case 5:
          return 'May'
        case 6:
          return 'June'
        case 7:
          return 'July'
        case 8:
          return 'August'
        case 9:
          return 'September'
        case 10:
          return 'October'
        case 11:
          return 'November'
        case 12:
          return 'December'
        default:
          return ''
      }
    },
  },
}
</script>

<template>
  <v-card rounded="xl">
    <v-card-title
      :class="$style.dateTitle"
      class="d-flex justify-space-between flex-grow-1 ml-5"
    >
      {{ title }}
      <v-btn :class="$style.dialogCloseBtn" icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text style="margin-top: -15px">
      <v-container fluid>
        <v-row no-gutters class="mb-2">
          <v-col cols="12" md="3" sm="3">
            <v-radio-group
              v-model="radios"
              mandatory
              @change="getSelectedDate(radios)"
            >
              <v-radio label="Today" value="Today"></v-radio>
              <v-radio label="Exact date" value="Exact_date"></v-radio>
              <v-radio label="Month & Year" value="Month_year"></v-radio>
              <v-radio label="Year only" value="Year_only"></v-radio>
              <v-radio label="In the past" value="In_the_past"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col v-if="notDesktop" cols="12" md="12" sm="12" class="text-left">
            <v-divider style="border-color: #000 !important"></v-divider>
          </v-col>
          <v-divider
            v-if="!notDesktop"
            vertical
            style="border-color: #000 !important"
          ></v-divider>

          <v-col cols="12" md="8" sm="10" class="pa-4">
            <v-row>
              <v-col cols="5">
                <v-menu v-model="monthMenu" top :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <p
                      v-if="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'In_the_past' ||
                          localSelectedDateType === 'Year_only'
                      "
                      class="text-left text--disabled"
                      :class="$style.dateCaption"
                      >Month</p
                    >
                    <p v-else class="text-left" :class="$style.dateCaption"
                      >Month</p
                    >
                    <v-text-field
                      :value="getMonthInString(month)"
                      readonly
                      role="button"
                      :disabled="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'In_the_past' ||
                          localSelectedDateType === 'Year_only'
                      "
                      solo
                      outlined
                      :class="$style.monthInput"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <MonthPicker :year="year" @set-month="setMonth" />
                </v-menu>
              </v-col>

              <v-col cols="3">
                <v-menu v-model="dayMenu" top :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <p
                      v-if="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'Month_year' ||
                          localSelectedDateType === 'In_the_past' ||
                          localSelectedDateType === 'Year_only'
                      "
                      class="text-left text--disabled"
                      :class="$style.dateCaption"
                      >Day</p
                    >
                    <p v-else class="text-left" :class="$style.dateCaption"
                      >Day</p
                    >
                    <v-text-field
                      :value="day"
                      readonly
                      role="button"
                      :disabled="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'Month_year' ||
                          localSelectedDateType === 'In_the_past' ||
                          localSelectedDateType === 'Year_only'
                      "
                      solo
                      outlined
                      :class="$style.dayInput"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <DayPicker :year="year" :month="month" @set-day="setDay" />
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-menu v-model="yearMenu" top :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <p
                      v-if="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'In_the_past'
                      "
                      class="text-left text--disabled"
                      :class="$style.dateCaption"
                      >Year</p
                    >
                    <p v-else class="text-left" :class="$style.dateCaption"
                      >Year</p
                    >
                    <v-text-field
                      :value="year"
                      readonly
                      role="button"
                      :disabled="
                        localSelectedDateType === 'Today' ||
                          localSelectedDateType === 'In_the_past'
                      "
                      solo
                      outlined
                      :class="$style.yearInput"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <YearPicker :years="years" @set-year="setYear" />
                </v-menu>
              </v-col>

              <p
                v-if="localSelectedDateType === 'In_the_past'"
                :class="$style.inThePastText"
                >* I don’t remember, it’s sometime in the past</p
              >
              <v-btn
                v-if="notDesktop"
                class="text-capitalize mt-5"
                rounded
                color="primary"
                :class="$style.saveBtnMobile"
                :disabled="
                  localSelectedDateType === 'Exact_date' &&
                    (year === null || day === null || month === null)
                "
                @click="
                  localSelectedDateType !== 'In_the_past'
                    ? setMedicalDate(false)
                    : setMedicalDate(true)
                "
              >
                Save
              </v-btn>
            </v-row>
            <p v-if="dateError" :class="$style.yearErrorMsg">{{ dateError }}</p>

            <v-btn
              v-if="!notDesktop"
              class="text-capitalize mt-5"
              rounded
              color="primary"
              :class="$style.saveBtnDesktop"
              :disabled="
                localSelectedDateType === 'Exact_date' &&
                  (year === null || day === null || month === null)
              "
              @click="
                localSelectedDateType !== 'In_the_past'
                  ? setMedicalDate(false)
                  : setMedicalDate(true)
              "
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';

.dateInputs {
  height: 50px;
  padding: 20px;
  border: 1px solid #a5abb3;
  border-radius: 5px;
}

.saveBtn {
  top: 8px;
  left: 8px;
  width: 100%;
  height: 60px;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #fff !important;
  text-align: center;
  background: #0476d9;
  border-radius: 32px;
}

.yearErrorMsg {
  margin-top: 14px !important;
  margin-left: 9px !important;
  font-size: 14px !important;
  color: #ca024f !important;
}

.saveBtnDesktop {
  top: 12px;
  left: 1px;
  width: 120px !important;
  height: 45px !important;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 30px;
  color: #fff !important;
  text-align: center;
  background: #0476d9;
  border-radius: 32px;
}

.saveBtnMobile {
  top: 12px;
  left: 8px;
  width: 90% !important;
  height: 45px !important;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 30px;
  color: #fff !important;
  text-align: center;
  background: #0476d9;
  border-radius: 32px;
}

.inThePastText {
  margin-bottom: 5px !important;
  margin-left: 10px;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
  color: #2c3a4b;
  text-align: left;
}

.dateCaption {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #2c3a4b;
  text-align: left;
  letter-spacing: 0;
}

.monthInput {
  left: 0;
  width: 188px;
  height: 63px;
  border-radius: 5px;
}

.dayInput {
  left: 0;
  width: 99px;
  height: 63px;
  border-radius: 5px;
}

.yearInput {
  left: 0;
  width: 123px;
  height: 63px;
  border-radius: 5px;
}

.dialogCloseBtn {
  width: 20px;
  height: 20px;
  color: #d1d1d1;
}

.dividerLine {
  width: 379px;
  border: 0.5px solid #000 !important;
}

.dateTitle {
  font-size: 25px !important;
  font-weight: 400;
  line-height: 38px;
  color: #000;
  text-align: left;
  letter-spacing: -0.30000001192092896px;
}

.radioBtnText {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  letter-spacing: 0;
}
</style>
